<template>
  <div class="container flex-line align-start m-theme" :class="{[theme_class]:true,
  'client-mobile':mobile}" style="align-items:stretch;justify-content:space-between;"
  >
    <app-bar v-if="!mobile" />
    <div :style="`height:100%;width:calc(100% - ${showAI ? 440 : 0}px);position:relative;overflow:hidden;`">
      <transition name="fade">
        <router-view id="rootView"></router-view>
      </transition>
    </div>
    <!-- <BaseColorHelper /> -->
    <!-- <app-bar-mobile v-if="mobile" /> -->
    <AiBot :style="`width:${showAI ? 440 : 0}px;transition:width 0.3s;`" />
  </div>
</template>

<script>
import AppBar from '@/components/appbar';
import AppBarMobile from '@/components/appbar-mobile';
import AiBot from '@/components/ai/aibot';

export default {
  data(){
    return {
    }
  },
  routerOption: {
    as_frame: true,
  },
  components: {AppBar, AppBarMobile, AiBot},

  computed: {
    theme_class() {
      return 'm-'+this.$store.getters['session/theme'];
    },
    mobile() {
      return this.$store.getters['session/mobile'];
    },
    showAI(){
      return this.$store.getters['session/showAI'];
    }
  },
  mounted() {
    this.$store.commit('session/resize');
   
  },
  created() {
    this.$bus.$once('401', ()=>{
      this.$store.commit('session/save_login_url', this.$route.fullPath);

      this.RouteTo('/');
    });

    this.$api.afterLogin(()=>{
      this.$store.dispatch('session/getUsers');
    });

    const that = this;
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer);
    }

    window.addEventListener('resize', (e)=>{
      that.resizeTimer = setTimeout(()=>{
        that.$bus.$emit('resize', {});
        that.$store.commit('session/resize', e);
        that.$forceUpdate();
      });
    });

    if (this.mobile) {
      document.body.addEventListener('touchmove', (e)=>{
        e.preventDefault();
      }, false);
    }
  },
};
</script>

<style lang="less">
.client-mobile{
  flex-direction: column;

}
</style>
